import { url } from 'inspector';
import axios, {errorCallBack} from './axios';
import {UserProps, UserEditProfileProps, UsersProps, SourcesProps} from './types';

interface IParams {
    searchParams: string | null,
    limit: string | null,
    sort: string | null,
    dateFrom: Date | null,
    dateTo: Date | null,
    page: string | null,
    filter?: string | null,
}

export const getUsersQuery = ({
                                  searchParams,
                                  sort,
                                  dateFrom,
                                  dateTo,
                                  limit,
                                  page,
                                  filter,
                              }: IParams): Promise<{ users: UsersProps[], dist: number }> => {
    return axios.get(`/admin/users?${searchParams ? `search=${encodeURIComponent(searchParams)}&` : ""}${sort ? `sort=${sort}&` : ""}${dateFrom ? `from=${dateFrom}&` : ""}${dateTo ? `to=${dateTo}&` : ""}${limit ? `limit=${limit}&` : ""}${page ? `page=${page}&` : ""}${filter ? `filter=${filter}&` : ""}`).then(({data}) => data).catch(errorCallBack);
};


export const getSourcesQuery = ({
                                    searchParams,
                                    sort,
                                    dateFrom,
                                    dateTo,
                                    limit,
                                    page,
                                }: IParams): Promise<{ sources: SourcesProps[], dist: number }> => {
    return axios.get(`/admin/sources?${searchParams ? `search=${searchParams}&` : ""}${sort ? `sort=${sort}&` : ""}${dateFrom ? `from=${dateFrom}&` : ""}${dateTo ? `to=${dateTo}&` : ""}${limit ? `limit=${limit}&` : ""}${page ? `page=${page}&` : ""}`).then(({data}) => data).catch(errorCallBack);
};

export const uploadRSSLinksQuery = (fileURL: string): Promise<{ sources: SourcesProps[], dist: number }> => {
    return axios.post(`/admin/rsslist`, {
        url: fileURL
    }).then(({data}) => data).catch(errorCallBack);
};

export const getUserQuery = (userId: string): Promise<UserProps> => {
    return axios.get(`/admin/users/${userId}`).then(({data}) => data).catch(errorCallBack);
};
export const userEditQuery = (data: UserEditProfileProps, userId: string): Promise<{ user: UserProps, userId: string }> => {
    return axios.patch(`/admin/users/${userId}`, data).then(({data}) => data).catch(errorCallBack);
};
export const deleteUserQuery = (users: string[]): Promise<any> => {
    return axios.post(`/admin/users/delete`, {users}).then(({data}) => data).catch(errorCallBack);
};

export const userChangePhotoQuery = (file: File, userId: string): Promise<{ user: UserProps }> => {
    const formData = new FormData();
    formData.append('image', file);
    return axios.patch(`/admin/users/${userId}/picture`, formData).then(({data}) => data).catch(errorCallBack);
};

export const uploadFile = (file: File): Promise<{ url: string }> => {
    const formData = new FormData();
    formData.append('csv', file);
    return axios.patch(`/admin/rsslist/csv`, formData).then(({data}) => data).catch(errorCallBack);
};

export const setAllToFreeTrialQuery = (): Promise<any> => {
    return axios.post(`/admin/subscriptions/freetrial/setall`).then(({data}) => data).catch(errorCallBack);
};

export const userSignInQuery = (userId: string): Promise<any> => {
    return axios.get(`/admin/users/${userId}/signin`).then(({data}) => data).catch(errorCallBack);
};

export const syncUserSubQuery = (userId: string): Promise<any> => {
    return axios.post(`/admin/users/${userId}/subscription/sync`).then(({data}) => data).catch(errorCallBack);
};

export interface StripeCharge {
    id: string;
    amount: number;
    currency: string;
    status: string;
    description: string | null;
    created: number;
    receiptUrl: string | null;
    paymentMethod: string | null;
    refunded: boolean;
    amountRefunded: number;
}

export interface UserPaymentsData {
    stripeCustomerId: string;
    currentSubscription: {
        planName: string;
        isActive: boolean;
        isTrial: boolean;
        startDate: string;
        endDate: string;
        trialEndDate: string | null;
        stripeSubscriptionId: string;
    } | null;
    charges: StripeCharge[];
}

export const getUserPaymentsQuery = (userId: string): Promise<UserPaymentsData> => {
    return axios.get(`/admin/users/${userId}/payments`).then(({data}) => data).catch(errorCallBack);
};
